<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" @click="cancel">{{ t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ t("Rating Range") }}</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="confirm" :disabled="minNumber == maxNumber" :strong="true">{{ t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-item>
      <ion-label class="ion-text-center">
        <h4>{{ t("Set Min & Max Rating") }}</h4>
       <h2>{{ minNumber }} {{ t("to") }} {{  maxNumber }}</h2>
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-range :pin="true" aria-label="Dual Knobs Range" :dual-knobs="true" :min="800" :max="2550" :step="50"   v-model="value"
      @ionKnobMoveStart="onIonKnobMoveStart"
    @ionKnobMoveEnd="onIonKnobMoveEnd"
      ></ion-range>

    </ion-item>
  </ion-content>
</template>

<script  setup>
  import {
    IonRange,
    IonContent,
    IonHeader,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    IonItem,
    IonInput,
    IonLabel,
    modalController,
  } from '@ionic/vue';
  import { defineComponent, ref } from 'vue';
  import { t } from "@/composables/translateText.js";

  const props = defineProps({
    min : Number,
    max : Number
	})

  const name = ref();

  const cancel = () => modalController.dismiss(null, 'cancel');
  const confirm = () => modalController.dismiss(value, 'confirm');

  var value = {lower: props.min, upper: props.max}
  var minNumber = ref(value.lower)
  var maxNumber = ref(value.upper)

  function onIonKnobMoveStart({ detail }) {
        //console.log('ionKnobMoveStart:', detail.value);
        //console.log("value is ",value)
        minNumber.value = value.lower
        maxNumber.value = value.upper
      }
  function onIonKnobMoveEnd({ detail }) {
        //console.log('ionKnobMoveEnd:', detail.value);
        //console.log("value is ",value)
        minNumber.value = value.lower
        maxNumber.value = value.upper
      }
</script>
